import { Code, Dialog } from '@neo4j-ndl/react';
import { CheckIconOutline, Square2StackIconOutline } from '@neo4j-ndl/react/icons';
import { useCopyWithMessage } from '@nx/ui';

const MetricsIntegrationConfigModal = ({
  open,
  onClose,
  prometheusConfig,
}: {
  open: boolean;
  onClose: () => void;
  prometheusConfig: string;
}) => {
  const [copyMessage, copyWithFeedback] = useCopyWithMessage();

  return (
    <Dialog isOpen={open} onClose={onClose} modalProps={{ 'data-testid': 'link-prometheus-config-modal' }}>
      <Dialog.Header>Prometheus job configuration</Dialog.Header>
      <Code
        language="yaml"
        code={prometheusConfig}
        theme="prism"
        actions={[
          {
            ariaLabel: 'Copy to clipboard',
            htmlAttributes: { title: 'Copy to clipboard' },
            size: 'small',
            children: /copied/i.test(copyMessage ?? '') ? <CheckIconOutline /> : <Square2StackIconOutline />,
            onClick: () => {
              void copyWithFeedback(prometheusConfig);
            },
          },
        ]}
      />
    </Dialog>
  );
};

export default MetricsIntegrationConfigModal;
